<mat-icon *ngIf="!value" matSuffix (click)="changeValue()" class="checkmark">
	star_border
</mat-icon>

<mat-icon *ngIf="value" matSuffix (click)="changeValue()" class="checkmark-checked">
	star
</mat-icon>